import {
  HttpErrorResponse,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NEVER, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  isUrlBlackListed(url) {
    let isBlacklisted = false;
    const urlList = [
      "/isactive?app",
      "/api/v1/research",
      "/analytics_pages/get_labs_page",
    ];
    const list = urlList.filter((val) => {
      return url.indexOf(val) !== -1;
    });
    if (list.length > 0) {
      isBlacklisted = true;
    }
    return isBlacklisted;
  }
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401 && !this.isUrlBlackListed(err.url)) {
            if (err.error.data && err.error.data.force_logout) {
              window.location.href = "/homepage/?force_logout=true";
            } else if (err.error.data && err.error.data.imitate_logout) {
              window.location.href = "/login";
            } else if (err.error.data && !err.error.data.accessible) {
              window.location.href = "/homepage";
            } else {
              window.location.href = "/login/";
            }
            return NEVER;
          }
          if (err.status === 403 && !this.isUrlBlackListed(err.url)) {
            window.location.href = "/login/";
            return NEVER;
          }
        }
        return throwError(err);
      }),
    );
  }
}
